// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"modal-title_modal_title__3xkHs","left":"modal-title_left__5ctjc"};